export default __webpack_public_path__ + "static/media/IconDesc_Geyser.256.0175f492.png";